import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import CertificatePremium from '../images/cards/certificate-premium.jpg';
import CertificateBasic from '../images/cards/certificate-basic.jpg';
import MasterfulMinds from '../images/cards/masterful-minds.jpg';
import PersonalFlyer from '../images/cards/personal-flyer.jpg';
import ArtistSlide from '../images/cards/artist-slide.jpg';
import UtilitiesProof from '../images/cards/utilities-proof.jpg';


function PageSelectorPageContent({ pathname }) {
	const navigate = useNavigate();

	return (
		<>
			<Typography variant="h4">Certificates</Typography>
			<Divider sx={{ m: 2 }} />
			<Grid container spacing={4} padding={2} columns={{ xs: 2, sm: 6, md: 6, xl: 12 }}>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="Simple" />
						<CardMedia component="img" height="194" image={CertificateBasic} alt="Simple Certificate" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								Simple certificate generator only allows for the artist's name.
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/certificates/simple')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="Divine" />
						<CardMedia component="img" height="194" image={CertificatePremium} alt="Divine Certificate" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								Divine certificate generator allows you to include both the artist's name and the title of the artwork.
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/certificates/divine')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
			</Grid>

			<Typography variant="h4">Pages</Typography>
			<Divider sx={{ m: 2 }} />
			<Grid container spacing={4} padding={2} columns={{ xs: 2, sm: 6, md: 6, xl: 12 }}>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="VD - Personal Flyer" />
						<CardMedia component="img" height="194" image={PersonalFlyer} alt="VD - Personal Flyer" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								VD - Personal Flyer
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/page-maker/flyer')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="VD - Video Slide" />
						<CardMedia component="img" height="194" image={ArtistSlide} alt="VD - Video Slide" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								VD - Video Slide
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/page-maker/slide')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="VD - Masterful Minds" />
						<CardMedia component="img" height="194" image={MasterfulMinds} alt="VD - Masterful Minds" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								VD - Masterful Minds
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/page-maker/masterful')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
			</Grid>

			<Typography variant="h4">Utilities</Typography>
			<Divider sx={{ m: 2 }} />
			<Grid container spacing={4} padding={2} columns={{ xs: 2, sm: 6, md: 6, xl: 12 }}>
				<Grid size={4}>
					<Card sx={{ maxWidth: 345 }}>
						<CardHeader title="VD - Proof" />
						<CardMedia component="img" height="194" image={UtilitiesProof} alt="VD - Proof" />
						<CardContent>
							<Typography variant="body1" sx={{ color: 'text.secondary' }}>
								VD - Proof
							</Typography>
						</CardContent>
						<CardActions>
							<Button size="small" onClick={() => navigate('/utilities/proof')}>Generate</Button>
						</CardActions>
					</Card>
				</Grid>
			</Grid>
		</>
	);
}

export default PageSelectorPageContent;